import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Avatar,
  Chip
} from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import DevicesIcon from '@mui/icons-material/Devices';
import CampaignIcon from '@mui/icons-material/Campaign';
import GroupIcon from '@mui/icons-material/Group';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EventIcon from '@mui/icons-material/Event';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SchoolIcon from '@mui/icons-material/School';

import AOS from 'aos';
import 'aos/dist/aos.css';

const services = [
  {
    icon: <WorkIcon />,
    title: 'Collaboration & Projects',
    description: 'AI, ML & Final-Year project building with mentor support.',
    badge: 'Paid',
  },
  {
    icon: <DevicesIcon />,
    title: 'Web & App Development',
    description: 'Full-stack business and mobile apps for clients.',
    badge: 'Paid',
  },
  {
    icon: <CampaignIcon />,
    title: 'Digital Marketing',
    description: 'SEO, branding, social media, and campaigns.',
    badge: 'Paid',
  },
  {
    icon: <GroupIcon />,
    title: 'Mentor Support',
    description: 'Career, interview, and domain-specific expert help.',
    badge: 'Free',
  },
  {
    icon: <CheckCircleIcon />,
    title: '100% Placement Program',
    description: 'Training with resume, aptitude, mock interviews.',
    badge: 'Paid',
  },
  {
    icon: <EventIcon />,
    title: 'Workshops & Bootcamps',
    description: 'Offline seminars, tech bootcamps, and college visits.',
    badge: 'Free',
  },
  {
    icon: <LaptopMacIcon />,
    title: 'Online Training',
    description: 'Live training with assignments and support.',
    badge: 'Paid',
  },
  {
    icon: <MonetizationOnIcon />,
    title: 'Free & Paid Courses',
    description: 'Access free workshops and premium certifications.',
    badge: 'Free',
  },
  {
    icon: <SchoolIcon />,
    title: 'Internships & Certifications',
    description: 'Verified internships with letter and tasks.',
    badge: 'Free',
  },
  {
    icon: <DevicesIcon />,
    title: 'Business Websites',
    description: 'Web presence for startups, portfolios & branding.',
    badge: 'Paid',
  },
  {
    icon: <GroupIcon />,
    title: 'Offline Placement Training',
    description: 'On-campus soft skills, HR prep, and technical rounds.',
    badge: 'Paid',
  },
  {
    icon: <EventIcon />,
    title: 'Campus Hiring Drives',
    description: 'Connect college talent with tech recruiters.',
    badge: 'Free',
  },
];

function ServicesSection() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <Box
      id="services"
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, sm: 4, md: 8 },
        background: 'radial-gradient(circle at top left, #112244, #0c1e3c)',
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          mb: 2,
          fontFamily: "'Space Grotesk', 'Poppins', sans-serif",
          color: '#ffcb05',
        }}
      >
        Our Services
      </Typography>

      <Typography
        variant="subtitle1"
        sx={{
          color: '#dddddd',
          maxWidth: '700px',
          mx: 'auto',
          mb: 5,
          fontSize: '1rem',
        }}
      >
        From learning to placement, we offer everything you need to launch your career.
      </Typography>

      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 80}
          >
            <Paper
              elevation={0}
              sx={{
                p: 4,
                borderRadius: 4,
                height: '100%',
                background: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                color: '#fff',
                transition: '0.4s ease',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                },
              }}
            >
              <Avatar
                sx={{
                  bgcolor: '#ffcb05',
                  color: '#0c1e3c',
                  width: 56,
                  height: 56,
                  mb: 2,
                  mx: 'auto',
                }}
              >
                {service.icon}
              </Avatar>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'bold',
                  mb: 1,
                  fontSize: '1.05rem',
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {service.title}
              </Typography>

              <Typography
                variant="body2"
                sx={{ color: '#cccccc', fontSize: '0.9rem', mb: 1 }}
              >
                {service.description}
              </Typography>

              <Chip
                label={service.badge}
                size="small"
                sx={{
                  backgroundColor:
                    service.badge === 'Free' ? '#00c853' : '#ffcb05',
                  color: service.badge === 'Free' ? '#fff' : '#0c1e3c',
                  fontWeight: 'bold',
                  fontSize: '0.75rem',
                  mt: 1,
                }}
              />
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ServicesSection;
